//consultas modulo credito-concentracion

import { gql } from "graphql-tag";

const getEvaluaciones = gql`
  query Query($idPlantilla: Int) {
    evaluaciones(idPlantilla: $idPlantilla) {
      id
      fechaContable
      idPlantilla
    }
  }
`;

const getAlertaTemprana = gql`
query Query($idEvaluacion: Int!, $idCuenta: String!) {
  detalleEvaluacionCuenta(idEvaluacion: $idEvaluacion, idCuenta: $idCuenta) {
    idCuenta
    valor
    idEvaluacion
  }
}`;

const getCreditos = gql`
query Query($periodo: String!) {
  creditos_sub_calculos(periodo: $periodo) {
    CRE_01 {
      value
    }
    CRE_02 {
      value
    }
    CRE_03 {
      value
    }
    CRE_04 {
      value
    }
    CRE_05 {
      value
    }
    CRE_06 {
      value
    }
    CRE_07 {
      value
    }
    CRE_08 {
      value
    }
    CRE_09 {
      value
    }
    CRE_10 {
      value
    }
    CRE_11 {
      value
    }
    CRE_12 {
      value
    }
    CRE_13 {
      value
    }
  }
}
`;

const getDataProducto = gql`
  query Query($periodo: String!) {
  ahorros_sub_calculos(periodo: $periodo) {
    AHO_13 {
      codigoTipoCuenta
      nombreTipoCuenta
      totalSaldo
      totalCuentas
      totalIntereses
    }
  }
}
`;
const getDataSaldo = gql`
  query Query($periodo: String!) {
  ahorros_sub_calculos(periodo: $periodo) {
    AHO_11 {
      de_0_100000 {
        totalSaldo 
        totalCuentas 
        totalIntereses
      }
      de_100001_500000 {
        totalSaldo 
        totalCuentas 
        totalIntereses
      }
      de_500001_1000000 {
        totalSaldo 
        totalCuentas 
        totalIntereses
      }
      de_1000001_2000000 {
        totalSaldo 
        totalCuentas 
        totalIntereses
      }
      de_2000001_5000000 {
        totalSaldo 
        totalCuentas 
        totalIntereses
      }
      de_5000001_10000000 {
        totalSaldo 
        totalCuentas 
        totalIntereses
      }
      de_10000001_20000000 {
        totalSaldo 
        totalCuentas 
        totalIntereses
      }
      de_20000001_30000000 {
        totalSaldo 
        totalCuentas 
        totalIntereses
      }
      mas_30000000 {
        totalSaldo 
        totalCuentas 
        totalIntereses
      }
    }
  }
}
`;
const getDataPlazo = gql`
  query Query($periodo: String!) {
    ahorros_sub_calculos(periodo: $periodo) {
      AHO_12 {
        de_1_30 {
          totalSaldo 
          totalCuentas 
          totalIntereses
        }
        de_181_360 {
          totalSaldo 
          totalCuentas
          totalIntereses
        }
        de_31_60 {
          totalSaldo 
          totalCuentas 
          totalIntereses
        }
        de_61_90 {
          totalSaldo 
          totalCuentas 
          totalIntereses
        }
        de_91_180 {
          totalSaldo 
          totalCuentas 
          totalIntereses
        }
        mas_360 {
          totalSaldo 
          totalCuentas 
          totalIntereses
        }
      }
    }
  }
`;

const mutation =  gql`
mutation Mutation($periodo: String!, $creditosSubCalculos: CreditosSubcalculosInput!) {
  update_creditos_sub_calculos_by_period(periodo: $periodo, creditosSubCalculos: $creditosSubCalculos) {
    ind {
      limits {
        max
        min
      }
    }
  }
}`

const setLimites = gql`
  mutation Update_ahorros_propiedades_adicionales($periodo: DateTime!, $institucionId: String, $propiedades: PropiedadesAhorrosInput!) {
    update_ahorros_propiedades_adicionales(periodo: $periodo, institucionID: $institucionId, propiedades: $propiedades) {
      periodo
      propiedades
    }
  }
`;

const getPropieties = gql`
  query Adicionales($periodo: String!, $institucionId: String) {
    ahorros_sub_calculos(periodo: $periodo) {
      adicionales(institucionID: $institucionId) {
        periodo
        propiedades
      }
    }
  }
`;

const getDetalleCuenta = gql`
  query Query($idEvaluacion: Int!, $idCuenta: String!, $params: FindOneAccountEDInput) {
    detalleEvaluacionCuenta(idEvaluacion: $idEvaluacion, idCuenta: $idCuenta, params: $params) {
      idCuenta
      idEvaluacion
      valor
    }
  }
`;

const getCuenta = gql`
  query Cuenta($cuentaId: String, $idPlantilla: Int, $params: FindOneAccountInput) {
    cuenta(id: $cuentaId, idPlantilla: $idPlantilla, params: $params) {
      id
      descripcion
      tipo
      idPais
      idPlantilla
    }
  }
`;

const getDetalleVarTemp = gql`
  query Query($idEvaluacion: Int!, $idVarTemp: String!) {
    detalleEvaluacionVarTemp(idEvaluacion: $idEvaluacion, idVarTemp: $idVarTemp) {
      idEvaluacion
      idVarTemp
      valor
    }
  }
`;

const getVarTemp = gql`
  query Query($params: FindOneVarTempInput, $varTempId: String!, $idPlantilla: Int) {
    varTemp(params: $params, id: $varTempId, idPlantilla: $idPlantilla) {
      descripcion
      id
    }
  }
`;

const getVariable = gql`
  query Query($idEvaluacion: Int!, $idVariable: String!) {
    detalleEvaluacionVariable(idEvaluacion: $idEvaluacion, idVariable: $idVariable) {
      idEvaluacion
      idVariable
      valor
    }
  }
`;

const getAhorros = gql `
  query Query($periodo: String!) {
    ahorros_sub_calculos(periodo: $periodo) {
      AHO_02 {
        de_1_7
        de_8_15
        de_16_30
        de_31_60
        de_61_90
        de_91_180
        de_181_360
        mas_360
      }
      AHO_09 {
        de_1_7
        de_8_15
        de_16_30
        de_31_60
        de_61_90
        de_91_180
        de_181_360
        mas_360
      }
      AHO_03
      AHO_04
      AHO_05
    }
  }
`;

const getAmortizacion = gql`
  query Query($periodo: String!) {
    liquidaciones_sub_calculos(periodo: $periodo) {
      LIQ_01 {
        de_1_7
        de_8_15
        de_16_30
        de_31_60
        de_61_90
        de_91_180
        de_181_360
        mas_360
      }
      LIQ_02 {
        de_1_7
        de_8_15
        de_16_30
        de_31_60
        de_61_90
        de_91_180
        de_181_360
        mas_360
      }
    }
  }
`;

const getCuentasProm = gql`
  query Query($idEvaluacion3: Int!,$idEvaluacion2: Int!,$idEvaluacion1: Int!, $idCuenta: String!) {
    val1:
    detalleEvaluacionCuenta(idEvaluacion: $idEvaluacion1, idCuenta: $idCuenta) {
      idCuenta
      idEvaluacion
      valor
    }
    val2:
    detalleEvaluacionCuenta(idEvaluacion: $idEvaluacion2, idCuenta: $idCuenta) {
      idCuenta
      idEvaluacion
      valor
    }
    val3:
    detalleEvaluacionCuenta(idEvaluacion: $idEvaluacion3, idCuenta: $idCuenta) {
      idCuenta
      idEvaluacion
      valor
    }
  }
`;

const getVarTempProm = gql`
  query Query($idEvaluacion1: Int!,$idEvaluacion2: Int!,$idEvaluacion3: Int!, $idVarTemp: String!) {
    val1:
    detalleEvaluacionVarTemp(idEvaluacion: $idEvaluacion1, idVarTemp: $idVarTemp) {
      idEvaluacion
      idVarTemp
      valor
    }
    val2:
    detalleEvaluacionVarTemp(idEvaluacion: $idEvaluacion2, idVarTemp: $idVarTemp) {
      idEvaluacion
      idVarTemp
      valor
    }
    val3:
    detalleEvaluacionVarTemp(idEvaluacion: $idEvaluacion3, idVarTemp: $idVarTemp) {
      idEvaluacion
      idVarTemp
      valor
    }
  }
`;

const getVarProm = gql`
  query Query($idEvaluacion1: Int!,$idEvaluacion2: Int!,$idEvaluacion3: Int!, $idVariable: String!) {
    val1:
    detalleEvaluacionVariable(idEvaluacion: $idEvaluacion1, idVariable: $idVariable) {
      idEvaluacion
      idVariable
      valor
    }
    val2:
    detalleEvaluacionVariable(idEvaluacion: $idEvaluacion2, idVariable: $idVariable) {
      idEvaluacion
      idVariable
      valor
    }
    val3:
    detalleEvaluacionVariable(idEvaluacion: $idEvaluacion3, idVariable: $idVariable) {
      idEvaluacion
      idVariable
      valor
    }
  }
`;

const getAsientos = gql`
  query Query($periodo: String!) {
    creditos_sub_calculos(periodo: $periodo) {
      ASI_01 {
        de_1_7
        de_8_15
        de_16_30
        de_31_60
        de_61_90
        de_91_180
        de_181_360
        mas_360
      }
      ASI_02 {
        de_1_7
        de_8_15
        de_16_30
        de_31_60
        de_61_90
        de_91_180
        de_181_360
        mas_360
      }
    }
  }
`;

const getAditionals = gql`
  query Creditos_sub_calculos($periodo: String!, $subColeccion: String) {
    creditos_sub_calculos(periodo: $periodo) {
      adicionales(subColeccion: $subColeccion) {
        periodo
        propiedades
      }
    }
  }
`;

const getInversiones = gql`
  query Query($periodo: String!) {
    inversiones_sub_calculos(periodo: $periodo) {
      INV_01 {
        de_1_7
        de_8_15
        de_16_30
      }
      INV_02 {
        de_31_60
        de_61_90
        de_91_180
        de_181_360
        mas_360
      }
    }
  }
`;

const getInversion1 = gql`
  query Query($periodo: String!) {
    inversiones_sub_calculos(periodo: $periodo) {
      INV_01 {
        de_1_7
        de_16_30
        de_8_15
      }
    }
  }
`;

const getLiquidez = gql`
  query Ahorros_sub_calculos($periodo: String!) {
    liquidaciones_sub_calculos(periodo: $periodo) {
      LIQ_01 {
        de_16_30
        de_1_7
        de_8_15
      },
      LIQ_02 {
        de_16_30
        de_1_7
        de_8_15
      }
    }
  }
`;


const postAdicionales = gql`
  mutation Mutation($periodo: DateTime!, $propiedades: AsientosPropertiesInput!, $subColeccion: String) {
    update_asientos_propiedades_adicionales(periodo: $periodo, propiedades: $propiedades, subColeccion: $subColeccion) {
      periodo
      propiedades
    }
  }
`;

const getSubcalculosIndProduc = gql`
  query Query($idInstitucion: String!, $periodos: [PeriodoInput!]!) {
    subcalculosIndicadores(idInstitucion: $idInstitucion, periodos: $periodos) {
      periodo,
      anio,
      mes,
      numeroTotalSociosClientes
      numeroSociosClientesNuevosEnMes
      numeroSociosClientesNuevosEnAnio
      numeroCreditosVigentes
      numeroCreditosDesembolsadosEnMes
      numeroCreditosDesembolsadosEnAnio
      montoCreditosDesembolsadoEnMes
      montoCreditosDesembolsadoEnAnio
    }
  }
`;
const getPeriodosLiquidez = gql`
query GetPeriodsLiquidezSubcalculation($idInstitucion: String!) {
  getPeriodsLiquidezSubcalculation(idInstitucion: $idInstitucion) {
    year
    month
    period
  }
}
`;
const getPerspectivas = gql`
query Query {
  liquidezPerspectives
}
`;
const getConcentracionLiquidez= gql`
query GetConcentracionLiquidez($anio: Float!, $mes: Float!, $idInstitucion: String!) {
  getConcentracionLiquidez(anio: $anio, mes: $mes, idInstitucion: $idInstitucion) {
    entity {
      segments {
        saldo
        moneda
        segment
        limits {
          min
          max
        }
      }
      perspective
    }
    expiration {
      perspective
      segments {
        saldo
        moneda
        segment
        limits {
          min
          max
        }
      }
    }
  }
}`;

const getGAPRiesgos =gql` 
query ExampleQuery($idInstitucion: String!, $mes: Float!, $anio: Float!) {
  getGap(idInstitucion: $idInstitucion, mes: $mes, anio: $anio) {
    name
    mes
    anio
    bandas {
      label
      valor
      order
    }
  }
}
`;

const getRCL = gql`
query ExampleQuery($anio: Float!, $mes: Float!, $idInstitucion: String!) {
  getRCL(anio: $anio, mes: $mes, idInstitucion: $idInstitucion) {
    name
    mes
    anio
    valor
  }
}
`;

export {
  getEvaluaciones,
  getAlertaTemprana,
  getCreditos,
  mutation,
  getDataProducto,
  getDataSaldo,
  getDataPlazo,
  setLimites,
  getPropieties,
  getDetalleCuenta,
  getCuenta,
  getDetalleVarTemp,
  getVarTemp,
  getVariable,
  getAhorros,
  getAmortizacion,
  getCuentasProm,
  getVarTempProm,
  getVarProm,
  getAsientos,
  getAditionals,
  getInversiones,
  getInversion1,
  postAdicionales,
  getLiquidez,
  getSubcalculosIndProduc,
  getPeriodosLiquidez,
  getPerspectivas,
  getConcentracionLiquidez,
  getGAPRiesgos,
  getRCL,
}